export default "__VITE_ASSET__4310f400__"